// Init i18n
import { SnackbarContext, SnackbarProvider } from '@pets-ui/Snackbar/SnackbarProvider'
import { SnackbarVariants } from '@pets-ui/Snackbar/SnackbarVariants'
import { I18nextProvider } from 'react-i18next'
import { Route, Switch } from 'react-router-dom-v5'
import { NotFound } from './components/NotFound'
import { i18nInstance } from './i18n/config'
import { AdminRouters } from './pages/admin/AdminRouters'
import { CampaignAuthProcessingWithGroupBuying } from './pages/campaign/CampaignAuthProcessingWithGroupBuying'
import { CampaignGroupBuying } from './pages/campaign/CampaignGroupBuying'
import { CampaignRouters } from './pages/campaign/CampaignRouters'
import { ClientHome } from './pages/campaign/client-home'
import { MerchantRouters } from './pages/merchant/MerchantRouters/MerchantRouters'
import { StmRouters } from './pages/shepherdtech-market/StmRouters'

function App() {
  return (
    <I18nextProvider i18n={i18nInstance}>
      <SnackbarProvider>
        <SnackbarContext.Consumer>
          {(value) => {
            const { handleExited, snackbarProps, closeSnackbar } = value || {}
            return <SnackbarVariants autoHideDuration={3000} {...snackbarProps} onClose={closeSnackbar} onExited={handleExited} />
          }}
        </SnackbarContext.Consumer>
        <Switch>
          <Route path="/" exact><ClientHome /></Route>
          <Route path="/merchant/:code/">
            <MerchantRouters />
          </Route>
          <Route path="/admin/:campaignID/">
            <AdminRouters />
          </Route>
          <Route path="/campaigns/:campaignID/group-buying">
            <CampaignGroupBuying />
          </Route>
          <Route path="/campaigns/:campaignID/auth-processing-with-group-buying">
            <CampaignAuthProcessingWithGroupBuying />
          </Route>
          <Route path="/campaigns/:campaignID/">
            <CampaignRouters />
          </Route>
          <Route path="/shepherdtech-market/:countryCode(hk)?">
            <StmRouters />
          </Route>
          <Route path="*"><NotFound /></Route>
        </Switch>
      </SnackbarProvider>
    </I18nextProvider>
  )
}

export default App
